export const iconFontAwesomePoliticalCheckDouble = (
	<i className="fa-solid fa-check-double"></i>
);
